import React from "react";
import { H2 } from "BaseComponents/Text";

import { Grid, Info } from "./";
export const SocialMediaColumn = ({
  facebook,
  SocialMediaHeading,
  twitter,
  instagram,
  linkedIn,
  youtube,
  useThree,
  tiktok
}) => {
  return (
    <Grid useThree={useThree}>
      {SocialMediaHeading && <H2 fontWeight="700">{SocialMediaHeading}</H2>}
      <Info
        className="footerInfo_section"
        margin={currentTheme === "norlandiacare" ? "0" : undefined}
      >
        {facebook != null && (
          <a
            target="_blank"
            className="element-link--footer"
            href={facebook.Url}
          >
            <i
              className={
                currentTheme === "norlandiacare"
                  ? "fa-facebook fa-brands"
                  : "icon-facebook"
              }
            ></i>
            <span>{facebook.Name}</span>
          </a>
        )}
        {twitter != null && (
          <a
            target="_blank"
            className="element-link--footer"
            href={twitter.Url}
          >
            <i className="icon-twitter" aria-hidden="true"></i>
            <span>{twitter.Name}</span>
          </a>
        )}
         {tiktok != null && (
              <a
                  target="_blank"
                  className="element-link--footer"
                  href={tiktok.Url}
              >
                  <i className="fa-tiktok fa-brands" aria-hidden="true"></i>
                  <span>{tiktok.Name}</span>
              </a>
         )}
        {linkedIn != null && (
          <a
            target="_blank"
            className="element-link--footer"
            href={linkedIn.Url}
          >
            <i className="icon-linkedin" aria-hidden="true"></i>
            <span>{linkedIn.Name}</span>
          </a>
        )}
        {instagram != null && (
          <a
            target="_blank"
            className="element-link--footer"
            href={instagram.Url}
          >
            <i className="icon-instagram" aria-hidden="true"></i>
            <span>{instagram.Name}</span>
          </a>
        )}
        {youtube != null && (
          <a
            target="_blank"
            className="element-link--footer"
            href={youtube.Url}
          >
            <i className="icon-youtube" aria-hidden="true"></i>
            <span>{youtube.Name}</span>
          </a>
        )}
      </Info>
    </Grid>
  );
};
